import { Routes } from '@angular/router';
import { ReportComponent } from './report/report.component';

export const STATISTICS_ROUTES: Routes = [
  {
    path: '',
    component: ReportComponent
  }
];
